import Head from 'next/head';
import React from 'react';

import { renderJsonLdScript, getFaqStructuredData } from 'libs/universal/structuredData';
import FAQ_SEARCH_RESULTS from './faq_search_content';

const title = 'Wedding Guest List';
const description =
  'Simplify guest management with our guest list tool that helps you effortlessly organize, invite, and manage responses for a stress-free celebration.';

function GuestListHeader(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="Wedding, Wedding Registry, Honeymoon Fund, Wedding Planning, Guest List, Wedding Checklist, Wedding Website, Free wedding website"
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png"
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="zola.com" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <link rel="canonical" href="https://www.zola.com/wedding-planning/guests" />
      {renderJsonLdScript(getFaqStructuredData(FAQ_SEARCH_RESULTS))}
    </Head>
  );
}

export default GuestListHeader;
